export const navbarTexts = {
    home: "Home",
    cv: "CV",
    aboutMe: "About Me",
    contact: "Contact",
    servicesApps: "Services & Apps",
}

export const slideshowTexts = {
    img1 : "Hello, I am Viktor Asenov, a.k.a. Rokyuto, and am happy that You are visiting my website. I am a System Programmer (as for now), working in the AI and Game Development area fields. In this page, You can find an overview of my project, developed so far. If you have an interest in reaching me, don't hesitate and use the ",
    img2: 'Won the "Programmer of the Alumni 19*" award.',
    img3: 'Photo from the development process of my graduation project - "Beat The Math" video game.',
    hrefText: 'Contact page'
}

export const projectsTexts = {
    AI_DUB_Pipeline: {
        title: "Automated Dubbing Pipeline using AI",
        description: "A system that automatically generates English dub from any spoken language while preserving the original speaker's voice.",
        development: "The system is constructed as a seven-stage pipeline, with each stage performing a specific task. Stage 1: Audio Source Separation (used Demucs), Stage 2: Speaker Diarization (used pyannote's pretrained AI model for speaker diarization), Stage 3: Speech Segment Extraction (used pydub), Stage 4: Speech-to-Text (used Whisper), Stage 5: Translation (used Google Translate API), Stage 6: Text-to-Speech (used Coqui TTS - xtts_v2 with voice clonning), Stage 7: Audio Reconstruction (used pydub). Stage 3-7 are applied for each speech segment extracted in Stage 2.",
        developedWith: "Developed with: Python",
        completionDate: "Completed on: 31 Jul 2025",
        videoText: "Watch demo here"
    },
    DrivingRecords: {
        title: "Driving Records",
        description: "You are a person, who enjoys to drive and wants to have an idea how many kilometers You have drove? This mobile application allows you to store every driving You have done - distance, date, car. The app also offers live tracking/recording.",
        development: "Idea: Interactive app to make the life easier for the passionate people, who want to keep track on their drive through the time",
        developedWith: "Developed with: Kotlin, Firebase",
        completionDate: "Completed on: 8 Jan 2025",
        videoText: "Watch showcase of the app here"
    },
    AI_BanknoteRecognisionApp: {
        title: "AI Banknotes Recognition",
        description: "Mobile application designed for EUR and BGN banknotes recognitions. Returns image with recognized features on it, text and speech with the recognition result.",
        development: "Development: 1. Fine-tune YOLOv8m model, 2. Create a DEMO GUI App with Tkinter toolkit, 3. Develop Mobile Application as final service using Expo and FastAPI",
        developedWith: "Developed with: Python, TypeScript",
        completionDate: "Completed on: 28 Sep 2024"
    },
    AI_KPoPIdolsRecognition: {
        title: "AI KPoP Idols Recognition",
        description: "A system to recognize face from an image and make a classification in the area of  the KPoP Idols.",
        development: "Development: Fine-tune the ArcFace model",
        developedWith: "Developed with: Python",
        completionDate: "Completed on: 23 Sep 2024",
        videoText: "Watch demo here"
    },
    AI_TicTacToePlayer: {
        title: "AI TicTacToe Player",
        description: "Don't have a person to play with you? Or you want to challenge yourself? Then, the AI TicTacToe Player is the perfect opponent for you.",
        development: "Development: Uses the Minimax algorithm.",
        developedWith: "Developed with: Python",
        completionDate: "Completed on: 1 Aug 2024",
        videoText: "Watch the full gameplay here"
    },
    BeatTheMath: {
        title: 'Beat the Math', 
        description: "Want to combine fun with a math? Test how fast you can calculate and even improve such skills with this game. Player's objective is to pass as many gates as he can by choosing the better gate to move through. Each door has a math function, which will REDUCE or INCREASE player's X value.", 
        development: "This was my school degree project" , 
        developedWith: "Developed with: Unreal Engine",
        completitionDate: "Completed on: 11 Mar 2024",
        videoText: "Watch gameplay of the game here" 
    },
    SpaceShooterGame: {
        title: 'Space Shooter Game', 
        description: "The Player is the defender of our planet Earth and managing his ship in the Space he has to destroy the enemies' spaceships by shooting them, before they pass him. He also has to be careful to don't let a enemy spaceship to touch him, because this collision whil destroy his rocket. The Player has 3 lifes.",
        development: "Developed as course project of Telerik School Academy's Game Development course", 
        developedWith: 'Developed with: Phaser (HTML5 Game Framework)', 
        completitionDate: "Completed on: 30 Jun 2023",
        videoText:"Watch the full gameplay here"
    },
    KPoP_Quiz: {
        title: 'KPoP Quiz',
        description: 'You are a KPoP fan? Then this mobile game will test how good you know this music area offering different quiz categories - "Guess the Idol", "Guess the Group", "Guess the song" and others.', 
        development: 'Main Idea: Explore the main rival of Unreal Engine in the game development - Unity', 
        developedWith: 'Developed with: Unity', 
        completionDate: "Completed on: 31 Jul 2022",
        videoText: 'Watch gameplay of the game here'
    },
    EndlessRunner: {
        title: 'Endless Runner', 
        description: "Player has to jump over or crouch under the barriers, that are moving toward him. On collision with any, the player is coming close to the edge and will fall in the toxic liquid that is down there.", 
        development: "Personal Challenge: Create a game within 2 hours", 
        developedWith: 'Developed with: Unreal Engine, Blender', 
        completionDate: "Completed on: 13 Mar 2022",
        videoText: "Watch the full gameplay here"
    },
    InfiniteKorean: {
        title: 'Infinite Korean', 
        description: 'Want to learn a language on your own when you decide? "Infinite Korean" offers you a set of words in popular topics (numbers, animals, colors, etc.) giving you a basic skill to write, speak and understand simple sentences.' , 
        development: 'Aim: Recreate a popular mobile application (Infinite ... series). This is my first "big" and finished project.' , 
        developedWith: 'Developed with: C# and Xamarin' ,
        completionDate: "Completed on: 26 Jan, 2022",
        videoText: "Watch gameplay of the game here"
    }
}

export const homeTexts = {
    headerText: 'Overview of the projects I have developed so far',
    showMore: 'Show more',
}

export const aboutMeTexts = {
    title: "About Me",
    greeting_part1: "Hello! I am ", 
    name: "Viktor Asenov",
    greeting_part2: " years old, from Pleven, Bulgaria.",
    paragraph1: "Since childhood, I have been interested in computer games. Initially, I only wanted to play, but over time I started to get curious about game development. So, I told my uncle about my desire to create games and be like him (he's a Game Designer). That's when I began working with Unreal Engine back in the summer of 2019.",
    paragraph2_part1: "At the start, I was struggling to make up my mind. There were questions like: ",
    paragraph2_part2: "Where I should start from?",
    paragraph2_part3: "How to create this in the most correct way?",
    paragraph2_part4: ", so the first year was understanding what this engine offers and learning all kinds of things - Different Blueprint Use-cases, Level Design, VFX effects, Widgets, and developing different functionalities without aiming to create something completed as a product in the end. Then, from the second year, I found myself understanding more or less what is going on and it became easier to start",
    paragraph2_part5: "challenging myself to create something whole",
    paragraph3_part1: "Meanwhile, I enrolled in the ",
    paragraph3_part2: "National Vocational High School of Computer Technologies and Systems",
    paragraph3_part3: ", located in Pravets, where the students graduate with a professional qualification as a ",
    paragraph3_part4: "System Programmer",
    paragraph3_part5: "At the beginning, I was not interested in programming",
    paragraph3_part6: " - my full attention was focussed in the Blueprints and Unreal Engine. But at ",
    paragraph3_part7: "10th grade at school",
    paragraph3_part8: ", we started having more lectures and practical exercises of programming, and that was the moment, when ",
    paragraph3_part9: "I found myself entertained and being absorbed in the writing of code",
    paragraph4_part1: 'So, I paused my learning of Unreal Engine and focussed on developing something with code, not Blueprint like until now. I interacted with the Website Development, then with Mobile Apps Development - by creating MY own version of "Infinite Korean", using C# and Xamarin. After that, I decided to get to know Unity, because it was praised by many people and while the Unreal Engine, was offering C++ as a programming language to develop video games, Unity was using C#, which was already known language by me. That was when the "KPoP Quiz" game was created. I also created a shooter game with Unity. At 11th grade, in school we were studying websites, which was something that I have already explored, so in my personal study road, I started pushing Python. Then I returned to Unreal Engine, aimed to interact with C++. During my ',
    paragraph4_part2: "12th grade",
    paragraph4_part3: ", the ",
    paragraph4_part4: "Artificial Intelligence",
    paragraph4_part5: " started to raise up noise, and after finishing all exams and graduate the school, I started to learn AI, founding it really ",
    paragraph4_part6: "interesting, fun and passionately",
    paragraph5_part1: "And that is how in 2024, I continue my education abroad - in ",
    paragraph5_part2: "Johannes Kepler University",
    paragraph5_part3: ", in Linz, with Bachelor's major in ",
    paragraph5_part4: "Artificial Intelligence",
    paragraph6_part1: "I am passionate about: ",
    paragraph6_part2: "Artificial Intelligence",
    paragraph6_part3: " and ",
    paragraph6_part4: "Game Development",
    paragraph7: "Beside programming and video games, I am also a car lover and sportman, having an activity daily which helps me to stay motivated and inspired.",
    paragraph8: "I am always eager to learn new things and take on new challenges.",
    paragraph9_part1: "If you want to get in touch with me, use the ",
    paragraph9_part2: "Contact page",
    paragraph9_part3: ". I am open to collaborations and new opportunities. Hope to work together!",
}

export const contactTexts = {
    title: 'Send me a message',
    name: 'Your Name',
    email: 'Your Email',
    subject: "Subject",
    subject_business: "Business Collaboration",
    subject_consulatation: "Consultation",
    subject_other: "Other",
    subject_placeholder: "Enter your subject",
    message: "Your Message",
    buttonText: "Send Message",
    errors: {
        nameError: 'Name is required',
        emailError: 'Email is required',
        invalidEmailError: 'Invalid email',
        subjectError: 'Subject is required',
        messageError: 'Message is required',
    },
    alerts: {
        waitMessage: 'Please wait...',
        successfulMessage: 'Your email was sent successfully!',
        unsuccessfullMessage: 'Failed to send email. Please try again later.',
        errorMessage: 'An error occurred. Please try again later.',
    }
}

export const footerTexts = {
    termsOfService: "Terms of Service",
    privacyPolicy: "Privacy Policy",
    viewMyWork: "View my work",
    contact: "Contact",
    copyright: "© Copyright 2024 Rokyuto. All Rights Reserved."
}
